import React from 'react';

export const StarHeart = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="none"
  >
    <path
      d="M99.6875 170.037L166.172 211.347C168.714 214.205 169.947 218.019 169.563 221.847L162.848 288.576C161.321 303.732 176.634 314.982 190.564 308.803L251.585 281.759C255.07 280.215 259.039 280.215 262.525 281.759L323.547 308.803C337.474 314.974 352.789 303.734 351.261 288.576L344.547 221.846C344.163 218.018 345.395 214.206 347.936 211.348L411.339 173.473V443.165C411.339 459.152 395.115 469.951 380.484 463.698L261.922 413.022C258.776 411.682 255.231 411.668 252.086 412.988L130.398 464.009C115.788 470.13 99.6875 459.332 99.6875 443.414V170.037Z"
      fill="url(#paint0_linear_3091_408)"
    />
    <path
      d="M99.6875 170.037L166.172 211.347C168.714 214.205 169.947 218.019 169.563 221.847L162.848 288.576C161.321 303.732 176.634 314.982 190.564 308.803L251.585 281.759C255.07 280.215 259.039 280.215 262.525 281.759L323.547 308.803C337.474 314.974 352.789 303.734 351.261 288.576L344.547 221.846C344.163 218.018 345.395 214.206 347.936 211.348L411.339 173.473V443.165C411.339 459.152 395.115 469.951 380.484 463.698L261.922 413.022C258.776 411.682 255.231 411.668 252.086 412.988L130.398 464.009C115.788 470.13 99.6875 459.332 99.6875 443.414V170.037Z"
      fill="url(#paint1_radial_3091_408)"
    />
    <path
      d="M99.6875 170.037L166.172 211.347C168.714 214.205 169.947 218.019 169.563 221.847L162.848 288.576C161.321 303.732 176.634 314.982 190.564 308.803L251.585 281.759C255.07 280.215 259.039 280.215 262.525 281.759L323.547 308.803C337.474 314.974 352.789 303.734 351.261 288.576L344.547 221.846C344.163 218.018 345.395 214.206 347.936 211.348L411.339 173.473V443.165C411.339 459.152 395.115 469.951 380.484 463.698L261.922 413.022C258.776 411.682 255.231 411.668 252.086 412.988L130.398 464.009C115.788 470.13 99.6875 459.332 99.6875 443.414V170.037Z"
      fill="url(#paint2_radial_3091_408)"
    />
    <path
      d="M99.6875 170.037L166.172 211.347C168.714 214.205 169.947 218.019 169.563 221.847L162.848 288.576C161.321 303.732 176.634 314.982 190.564 308.803L251.585 281.759C255.07 280.215 259.039 280.215 262.525 281.759L323.547 308.803C337.474 314.974 352.789 303.734 351.261 288.576L344.547 221.846C344.163 218.018 345.395 214.206 347.936 211.348L411.339 173.473V443.165C411.339 459.152 395.115 469.951 380.484 463.698L261.922 413.022C258.776 411.682 255.231 411.668 252.086 412.988L130.398 464.009C115.788 470.13 99.6875 459.332 99.6875 443.414V170.037Z"
      fill="url(#paint3_radial_3091_408)"
    />
    <path
      d="M99.6875 170.037L166.172 211.347C168.714 214.205 169.947 218.019 169.563 221.847L162.848 288.576C161.321 303.732 176.634 314.982 190.564 308.803L251.585 281.759C255.07 280.215 259.039 280.215 262.525 281.759L323.547 308.803C337.474 314.974 352.789 303.734 351.261 288.576L344.547 221.846C344.163 218.018 345.395 214.206 347.936 211.348L411.339 173.473V443.165C411.339 459.152 395.115 469.951 380.484 463.698L261.922 413.022C258.776 411.682 255.231 411.668 252.086 412.988L130.398 464.009C115.788 470.13 99.6875 459.332 99.6875 443.414V170.037Z"
      fill="url(#paint4_radial_3091_408)"
    />
    <path
      d="M99.6875 170.037L166.172 211.347C168.714 214.205 169.947 218.019 169.563 221.847L162.848 288.576C161.321 303.732 176.634 314.982 190.564 308.803L251.585 281.759C255.07 280.215 259.039 280.215 262.525 281.759L323.547 308.803C337.474 314.974 352.789 303.734 351.261 288.576L344.547 221.846C344.163 218.018 345.395 214.206 347.936 211.348L411.339 173.473V443.165C411.339 459.152 395.115 469.951 380.484 463.698L261.922 413.022C258.776 411.682 255.231 411.668 252.086 412.988L130.398 464.009C115.788 470.13 99.6875 459.332 99.6875 443.414V170.037Z"
      fill="url(#paint5_radial_3091_408)"
    />
    <path
      d="M99.6875 170.037L166.172 211.347C168.714 214.205 169.947 218.019 169.563 221.847L162.848 288.576C161.321 303.732 176.634 314.982 190.564 308.803L251.585 281.759C255.07 280.215 259.039 280.215 262.525 281.759L323.547 308.803C337.474 314.974 352.789 303.734 351.261 288.576L344.547 221.846C344.163 218.018 345.395 214.206 347.936 211.348L411.339 173.473V443.165C411.339 459.152 395.115 469.951 380.484 463.698L261.922 413.022C258.776 411.682 255.231 411.668 252.086 412.988L130.398 464.009C115.788 470.13 99.6875 459.332 99.6875 443.414V170.037Z"
      fill="url(#paint6_radial_3091_408)"
    />
    <path
      d="M99.6875 170.037L166.172 211.347C168.714 214.205 169.947 218.019 169.563 221.847L162.848 288.576C161.321 303.732 176.634 314.982 190.564 308.803L251.585 281.759C255.07 280.215 259.039 280.215 262.525 281.759L323.547 308.803C337.474 314.974 352.789 303.734 351.261 288.576L344.547 221.846C344.163 218.018 345.395 214.206 347.936 211.348L411.339 173.473V443.165C411.339 459.152 395.115 469.951 380.484 463.698L261.922 413.022C258.776 411.682 255.231 411.668 252.086 412.988L130.398 464.009C115.788 470.13 99.6875 459.332 99.6875 443.414V170.037Z"
      fill="url(#paint7_radial_3091_408)"
    />
    <path
      d="M99.6875 170.037L166.172 211.347C168.714 214.205 169.947 218.019 169.563 221.847L162.848 288.576C161.321 303.732 176.634 314.982 190.564 308.803L251.585 281.759C255.07 280.215 259.039 280.215 262.525 281.759L323.547 308.803C337.474 314.974 352.789 303.734 351.261 288.576L344.547 221.846C344.163 218.018 345.395 214.206 347.936 211.348L411.339 173.473V443.165C411.339 459.152 395.115 469.951 380.484 463.698L261.922 413.022C258.776 411.682 255.231 411.668 252.086 412.988L130.398 464.009C115.788 470.13 99.6875 459.332 99.6875 443.414V170.037Z"
      fill="url(#paint8_radial_3091_408)"
    />
    <path
      d="M239.087 55.4667C246.423 42.8028 264.612 42.8028 271.941 55.4667L310.152 121.453C312.838 126.089 317.337 129.384 322.557 130.517L396.761 146.677C411 149.779 416.618 167.175 406.913 178.105L356.324 235.048C352.766 239.048 351.049 244.375 351.585 249.715L359.23 325.691C360.699 340.276 345.98 351.026 332.647 345.119L263.169 314.326C258.286 312.164 252.722 312.164 247.838 314.326L178.36 345.119C165.028 351.033 150.308 340.276 151.778 325.691L159.423 249.715C159.959 244.375 158.242 239.048 154.684 235.048L104.095 178.105C94.3892 167.175 100.008 149.779 114.247 146.677L188.451 130.517C193.664 129.384 198.17 126.089 200.856 121.453L239.087 55.4667Z"
      fill="url(#paint9_radial_3091_408)"
    />
    <path
      d="M239.087 55.4667C246.423 42.8028 264.612 42.8028 271.941 55.4667L310.152 121.453C312.838 126.089 317.337 129.384 322.557 130.517L396.761 146.677C411 149.779 416.618 167.175 406.913 178.105L356.324 235.048C352.766 239.048 351.049 244.375 351.585 249.715L359.23 325.691C360.699 340.276 345.98 351.026 332.647 345.119L263.169 314.326C258.286 312.164 252.722 312.164 247.838 314.326L178.36 345.119C165.028 351.033 150.308 340.276 151.778 325.691L159.423 249.715C159.959 244.375 158.242 239.048 154.684 235.048L104.095 178.105C94.3892 167.175 100.008 149.779 114.247 146.677L188.451 130.517C193.664 129.384 198.17 126.089 200.856 121.453L239.087 55.4667Z"
      fill="url(#paint10_radial_3091_408)"
    />
    <path
      d="M239.087 55.4667C246.423 42.8028 264.612 42.8028 271.941 55.4667L310.152 121.453C312.838 126.089 317.337 129.384 322.557 130.517L396.761 146.677C411 149.779 416.618 167.175 406.913 178.105L356.324 235.048C352.766 239.048 351.049 244.375 351.585 249.715L359.23 325.691C360.699 340.276 345.98 351.026 332.647 345.119L263.169 314.326C258.286 312.164 252.722 312.164 247.838 314.326L178.36 345.119C165.028 351.033 150.308 340.276 151.778 325.691L159.423 249.715C159.959 244.375 158.242 239.048 154.684 235.048L104.095 178.105C94.3892 167.175 100.008 149.779 114.247 146.677L188.451 130.517C193.664 129.384 198.17 126.089 200.856 121.453L239.087 55.4667Z"
      fill="url(#paint11_radial_3091_408)"
    />
    <path
      d="M239.087 55.4667C246.423 42.8028 264.612 42.8028 271.941 55.4667L310.152 121.453C312.838 126.089 317.337 129.384 322.557 130.517L396.761 146.677C411 149.779 416.618 167.175 406.913 178.105L356.324 235.048C352.766 239.048 351.049 244.375 351.585 249.715L359.23 325.691C360.699 340.276 345.98 351.026 332.647 345.119L263.169 314.326C258.286 312.164 252.722 312.164 247.838 314.326L178.36 345.119C165.028 351.033 150.308 340.276 151.778 325.691L159.423 249.715C159.959 244.375 158.242 239.048 154.684 235.048L104.095 178.105C94.3892 167.175 100.008 149.779 114.247 146.677L188.451 130.517C193.664 129.384 198.17 126.089 200.856 121.453L239.087 55.4667Z"
      fill="url(#paint12_radial_3091_408)"
      fillOpacity="0.8"
    />
    <path
      d="M239.087 55.4667C246.423 42.8028 264.612 42.8028 271.941 55.4667L310.152 121.453C312.838 126.089 317.337 129.384 322.557 130.517L396.761 146.677C411 149.779 416.618 167.175 406.913 178.105L356.324 235.048C352.766 239.048 351.049 244.375 351.585 249.715L359.23 325.691C360.699 340.276 345.98 351.026 332.647 345.119L263.169 314.326C258.286 312.164 252.722 312.164 247.838 314.326L178.36 345.119C165.028 351.033 150.308 340.276 151.778 325.691L159.423 249.715C159.959 244.375 158.242 239.048 154.684 235.048L104.095 178.105C94.3892 167.175 100.008 149.779 114.247 146.677L188.451 130.517C193.664 129.384 198.17 126.089 200.856 121.453L239.087 55.4667Z"
      fill="url(#paint13_radial_3091_408)"
      fillOpacity="0.8"
    />
    <path
      d="M239.087 55.4667C246.423 42.8028 264.612 42.8028 271.941 55.4667L310.152 121.453C312.838 126.089 317.337 129.384 322.557 130.517L396.761 146.677C411 149.779 416.618 167.175 406.913 178.105L356.324 235.048C352.766 239.048 351.049 244.375 351.585 249.715L359.23 325.691C360.699 340.276 345.98 351.026 332.647 345.119L263.169 314.326C258.286 312.164 252.722 312.164 247.838 314.326L178.36 345.119C165.028 351.033 150.308 340.276 151.778 325.691L159.423 249.715C159.959 244.375 158.242 239.048 154.684 235.048L104.095 178.105C94.3892 167.175 100.008 149.779 114.247 146.677L188.451 130.517C193.664 129.384 198.17 126.089 200.856 121.453L239.087 55.4667Z"
      fill="url(#paint14_radial_3091_408)"
      fillOpacity="0.8"
    />
    <path
      d="M239.087 55.4667C246.423 42.8028 264.612 42.8028 271.941 55.4667L310.152 121.453C312.838 126.089 317.337 129.384 322.557 130.517L396.761 146.677C411 149.779 416.618 167.175 406.913 178.105L356.324 235.048C352.766 239.048 351.049 244.375 351.585 249.715L359.23 325.691C360.699 340.276 345.98 351.026 332.647 345.119L263.169 314.326C258.286 312.164 252.722 312.164 247.838 314.326L178.36 345.119C165.028 351.033 150.308 340.276 151.778 325.691L159.423 249.715C159.959 244.375 158.242 239.048 154.684 235.048L104.095 178.105C94.3892 167.175 100.008 149.779 114.247 146.677L188.451 130.517C193.664 129.384 198.17 126.089 200.856 121.453L239.087 55.4667Z"
      fill="url(#paint15_radial_3091_408)"
      fillOpacity="0.8"
    />
    <g clipPath="url(#clip0_3091_408)">
      <path
        d="M258.273 104.088C259.103 104.088 259.773 103.417 259.773 102.588C259.773 101.758 259.103 101.088 258.273 101.088C257.444 101.088 256.773 101.758 256.773 102.588C256.773 103.417 257.444 104.088 258.273 104.088Z"
        fill="#A97DEE"
      />
      <path
        d="M265.652 137.878C265.652 138.707 264.982 139.378 264.152 139.378C263.323 139.378 262.652 138.707 262.652 137.878C262.652 137.048 263.323 136.378 264.152 136.378C264.982 136.378 265.652 137.048 265.652 137.878Z"
        fill="#A97DEE"
      />
      <path
        d="M375.424 161.908C375.977 161.908 376.424 161.461 376.424 160.908C376.424 160.355 375.977 159.908 375.424 159.908C374.871 159.908 374.424 160.355 374.424 160.908C374.424 161.461 374.871 161.908 375.424 161.908Z"
        fill="#A97DEE"
      />
      <path
        d="M328.363 214.857C328.916 214.857 329.363 214.41 329.363 213.857C329.363 213.304 328.916 212.857 328.363 212.857C327.81 212.857 327.363 213.304 327.363 213.857C327.363 214.41 327.81 214.857 328.363 214.857Z"
        fill="#A97DEE"
      />
      <path
        d="M324.482 173.178C324.482 174.008 323.808 174.678 322.982 174.678C322.157 174.678 321.482 174.003 321.482 173.178C321.482 172.352 322.152 171.678 322.982 171.678C323.813 171.678 324.482 172.347 324.482 173.178Z"
        fill="#A97DEE"
      />
      <path
        d="M336.242 296.708C336.242 297.537 335.572 298.208 334.742 298.208C333.913 298.208 333.242 297.537 333.242 296.708C333.242 295.879 333.913 295.208 334.742 295.208C335.572 295.208 336.242 295.879 336.242 296.708Z"
        fill="#A97DEE"
      />
      <path
        d="M211.443 278.548C212.274 278.548 212.943 277.878 212.943 277.048C212.943 276.217 212.274 275.548 211.443 275.548C210.613 275.548 209.943 276.217 209.943 277.048C209.943 277.878 210.613 278.548 211.443 278.548Z"
        fill="#A97DEE"
      />
      <path
        d="M188.742 274.378C188.742 274.931 188.295 275.378 187.742 275.378C187.189 275.378 186.742 274.931 186.742 274.378C186.742 273.825 187.189 273.378 187.742 273.378C188.295 273.378 188.742 273.825 188.742 274.378Z"
        fill="#A97DEE"
      />
      <path
        d="M221.373 139.548C221.373 140.101 220.926 140.548 220.373 140.548C219.82 140.548 219.373 140.101 219.373 139.548C219.373 138.995 219.82 138.548 220.373 138.548C220.926 138.548 221.373 138.995 221.373 139.548Z"
        fill="#A97DEE"
      />
      <path
        d="M156.373 168.838C156.373 169.667 155.703 170.338 154.873 170.338C154.044 170.338 153.373 169.667 153.373 168.838C153.373 168.008 154.044 167.338 154.873 167.338C155.703 167.338 156.373 168.008 156.373 168.838Z"
        fill="#A97DEE"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M99.8301 170.126C100.55 172.952 101.947 175.687 104.094 178.105L154.683 235.048C158.241 239.048 159.958 244.375 159.423 249.715L151.778 325.692C150.308 340.276 165.028 351.033 178.36 345.119L247.838 314.327C252.721 312.164 258.285 312.164 263.169 314.327L332.647 345.119C345.979 351.026 360.699 340.276 359.229 325.692L351.584 249.715C351.048 244.375 352.766 239.048 356.324 235.048L406.912 178.105C407.885 177.01 408.703 175.85 409.375 174.646L411.339 173.473V175.224C410.56 176.693 409.586 178.107 408.408 179.434L357.819 236.376L357.818 236.377C354.634 239.957 353.094 244.728 353.574 249.516L361.219 325.491C362.841 341.581 346.591 353.485 331.836 346.948L262.359 316.155C257.991 314.221 253.015 314.221 248.648 316.155L179.171 346.947C164.415 353.493 148.166 341.58 149.788 325.491L157.433 249.516C157.913 244.728 156.373 239.957 153.189 236.377L153.188 236.376L102.599 179.433C101.431 178.118 100.463 176.717 99.6875 175.261V170.037L99.8301 170.126Z"
      fill="#F2F1F3"
    />
    <path
      d="M207.072 215.572C195.888 204.412 195.888 186.255 207.072 175.094C212.502 169.676 219.723 166.699 227.401 166.71C235.08 166.72 242.459 169.924 247.907 175.36L252.328 179.772C254.126 181.566 257.045 181.566 258.843 179.772L263.257 175.367C268.669 169.963 275.969 166.756 283.629 166.71C291.376 166.663 298.665 169.654 304.131 175.127C315.251 186.258 314.959 204.732 303.822 215.849L261.394 258.186C258.187 261.386 252.984 261.386 249.777 258.186L207.072 215.572Z"
      fill="#DFBDEF"
    />
    <path
      d="M207.072 215.572C195.888 204.412 195.888 186.255 207.072 175.094C212.502 169.676 219.723 166.699 227.401 166.71C235.08 166.72 242.459 169.924 247.907 175.36L252.328 179.772C254.126 181.566 257.045 181.566 258.843 179.772L263.257 175.367C268.669 169.963 275.969 166.756 283.629 166.71C291.376 166.663 298.665 169.654 304.131 175.127C315.251 186.258 314.959 204.732 303.822 215.849L261.394 258.186C258.187 261.386 252.984 261.386 249.777 258.186L207.072 215.572Z"
      fill="url(#paint16_radial_3091_408)"
    />
    <path
      d="M207.072 215.572C195.888 204.412 195.888 186.255 207.072 175.094C212.502 169.676 219.723 166.699 227.401 166.71C235.08 166.72 242.459 169.924 247.907 175.36L252.328 179.772C254.126 181.566 257.045 181.566 258.843 179.772L263.257 175.367C268.669 169.963 275.969 166.756 283.629 166.71C291.376 166.663 298.665 169.654 304.131 175.127C315.251 186.258 314.959 204.732 303.822 215.849L261.394 258.186C258.187 261.386 252.984 261.386 249.777 258.186L207.072 215.572Z"
      fill="url(#paint17_radial_3091_408)"
    />
    <path
      d="M207.072 215.572C195.888 204.412 195.888 186.255 207.072 175.094C212.502 169.676 219.723 166.699 227.401 166.71C235.08 166.72 242.459 169.924 247.907 175.36L252.328 179.772C254.126 181.566 257.045 181.566 258.843 179.772L263.257 175.367C268.669 169.963 275.969 166.756 283.629 166.71C291.376 166.663 298.665 169.654 304.131 175.127C315.251 186.258 314.959 204.732 303.822 215.849L261.394 258.186C258.187 261.386 252.984 261.386 249.777 258.186L207.072 215.572Z"
      fill="url(#paint18_radial_3091_408)"
    />
    <path
      d="M207.072 215.572C195.888 204.412 195.888 186.255 207.072 175.094C212.502 169.676 219.723 166.699 227.401 166.71C235.08 166.72 242.459 169.924 247.907 175.36L252.328 179.772C254.126 181.566 257.045 181.566 258.843 179.772L263.257 175.367C268.669 169.963 275.969 166.756 283.629 166.71C291.376 166.663 298.665 169.654 304.131 175.127C315.251 186.258 314.959 204.732 303.822 215.849L261.394 258.186C258.187 261.386 252.984 261.386 249.777 258.186L207.072 215.572Z"
      fill="url(#paint19_radial_3091_408)"
    />
    <path
      d="M207.072 215.572C195.888 204.412 195.888 186.255 207.072 175.094C212.502 169.676 219.723 166.699 227.401 166.71C235.08 166.72 242.459 169.924 247.907 175.36L252.328 179.772C254.126 181.566 257.045 181.566 258.843 179.772L263.257 175.367C268.669 169.963 275.969 166.756 283.629 166.71C291.376 166.663 298.665 169.654 304.131 175.127C315.251 186.258 314.959 204.732 303.822 215.849L261.394 258.186C258.187 261.386 252.984 261.386 249.777 258.186L207.072 215.572Z"
      fill="url(#paint20_radial_3091_408)"
    />
    <path
      d="M207.072 215.572C195.888 204.412 195.888 186.255 207.072 175.094C212.502 169.676 219.723 166.699 227.401 166.71C235.08 166.72 242.459 169.924 247.907 175.36L252.328 179.772C254.126 181.566 257.045 181.566 258.843 179.772L263.257 175.367C268.669 169.963 275.969 166.756 283.629 166.71C291.376 166.663 298.665 169.654 304.131 175.127C315.251 186.258 314.959 204.732 303.822 215.849L261.394 258.186C258.187 261.386 252.984 261.386 249.777 258.186L207.072 215.572Z"
      fill="url(#paint21_radial_3091_408)"
    />
    <path
      d="M207.072 215.572C195.888 204.412 195.888 186.255 207.072 175.094C212.502 169.676 219.723 166.699 227.401 166.71C235.08 166.72 242.459 169.924 247.907 175.36L252.328 179.772C254.126 181.566 257.045 181.566 258.843 179.772L263.257 175.367C268.669 169.963 275.969 166.756 283.629 166.71C291.376 166.663 298.665 169.654 304.131 175.127C315.251 186.258 314.959 204.732 303.822 215.849L261.394 258.186C258.187 261.386 252.984 261.386 249.777 258.186L207.072 215.572Z"
      fill="url(#paint22_radial_3091_408)"
    />
    <g clipPath="url(#clip1_3091_408)">
      <path
        d="M208.791 189.517C208.791 190.347 208.121 191.017 207.291 191.017C206.461 191.017 205.791 190.347 205.791 189.517C205.791 188.686 206.461 188.017 207.291 188.017C208.121 188.017 208.791 188.686 208.791 189.517Z"
        fill="#FBE577"
      />
      <path
        d="M299.111 190.017C299.665 190.017 300.111 189.57 300.111 189.017C300.111 188.463 299.665 188.017 299.111 188.017C298.558 188.017 298.111 188.463 298.111 189.017C298.111 189.57 298.558 190.017 299.111 190.017Z"
        fill="#FBE577"
      />
      <path
        d="M263.611 239.736C264.165 239.736 264.611 239.29 264.611 238.736C264.611 238.183 264.165 237.736 263.611 237.736C263.058 237.736 262.611 238.183 262.611 238.736C262.611 239.29 263.058 239.736 263.611 239.736Z"
        fill="#FBE577"
      />
      <path
        d="M285.422 191.017C286.251 191.017 286.922 190.346 286.922 189.517C286.922 188.687 286.251 188.017 285.422 188.017C284.592 188.017 283.922 188.687 283.922 189.517C283.922 190.346 284.592 191.017 285.422 191.017Z"
        fill="#FBE577"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3091_408"
        x1="257.619"
        y1="183.56"
        x2="257.619"
        y2="437.76"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A066FF" />
        <stop offset="0.260426" stopColor="#F289D3" />
        <stop offset="0.5698" stopColor="#FFB900" />
        <stop offset="1" stopColor="#FFDF8D" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(255.499 475.505) rotate(89.9947) scale(147.545 388.513)"
      >
        <stop offset="0.383013" stopColor="#F4F4F4" />
        <stop offset="0.757392" stopColor="#F4F4F4" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(136.873 164.316) rotate(85.7878) scale(116.348 47.9878)"
      >
        <stop offset="0.36908" stopColor="#5C34CB" />
        <stop offset="0.702738" stopColor="#A83FB6" />
        <stop offset="0.937986" stopColor="#F48CCF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(411.765 159.606) rotate(117.699) scale(160.437 30.082)"
      >
        <stop offset="0.308666" stopColor="#5C34CB" />
        <stop offset="0.621896" stopColor="#A83FB6" stopOpacity="0.9" />
        <stop offset="0.937986" stopColor="#E886DB" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(224.069 297.403) rotate(145.886) scale(130.759 70.9495)"
      >
        <stop offset="0.589099" stopColor="#DA9E00" />
        <stop offset="0.825908" stopColor="#FFC731" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(271.873 300.316) rotate(33.3964) scale(125.022 51.1454)"
      >
        <stop offset="0.684788" stopColor="#DA9E00" />
        <stop offset="0.900357" stopColor="#FFC62B" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(233.373 317.892) rotate(-20.6248) scale(59.835 24.478)"
      >
        <stop offset="0.684788" stopColor="#DA9E00" />
        <stop offset="1" stopColor="#DA9E00" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(156.073 273.247) rotate(92.386) scale(85.3045 88.6885)"
      >
        <stop stopColor="#FF6915" stopOpacity="0.85" />
        <stop offset="0.782411" stopColor="#FDCC20" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(454.38 276.798) rotate(90) scale(227.282 81.8525)"
      >
        <stop offset="0.308666" stopColor="#DB6900" />
        <stop offset="0.5016" stopColor="#D66700" stopOpacity="0.8" />
        <stop offset="0.864583" stopColor="#FFBF17" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(355.873 135.816) rotate(146.55) scale(462.624 503.671)"
      >
        <stop offset="0.0262609" stopColor="#E6D5D0" />
        <stop offset="0.572009" stopColor="#FCF1E8" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(264.873 239.816) rotate(45.9878) scale(41.0183 62.5276)"
      >
        <stop offset="0.559934" stopColor="#CAB9AE" />
        <stop offset="0.891388" stopColor="#F1E4DA" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(233.873 231.816) rotate(140.332) scale(53.2635 76.0558)"
      >
        <stop offset="0.559934" stopColor="#CAB9AE" />
        <stop offset="0.891388" stopColor="#F1E4DA" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(255.5 32) rotate(67.0447) scale(262.812 69.1425)"
      >
        <stop offset="0.410716" stopColor="#CAB9AE" />
        <stop offset="0.670567" stopColor="#ECDCD6" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint13_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(426.617 161.211) rotate(-172.248) scale(238.8 52.5017)"
      >
        <stop offset="0.348118" stopColor="#CAB9AE" />
        <stop offset="0.802161" stopColor="#EDDED8" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint14_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(356.873 291.816) rotate(-93.6914) scale(124.258 52.7559)"
      >
        <stop offset="0.348118" stopColor="#CAB9AE" />
        <stop offset="0.71943" stopColor="#EDDED8" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint15_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(70.4141 150.734) rotate(-10.1476) scale(231.203 64.4269)"
      >
        <stop offset="0.463808" stopColor="#CAB9AE" />
        <stop offset="0.799286" stopColor="#F5E8E0" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint16_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(270.209 242.48) rotate(45.0888) scale(18.9362 64.9089)"
      >
        <stop stopColor="#F52086" />
        <stop offset="1" stopColor="#DCB6EB" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(228.096 229.069) rotate(136.013) scale(49.2404 228.732)"
      >
        <stop stopColor="#F1328E" />
        <stop offset="1" stopColor="#DDB9F1" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint18_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(265.529 173.415) rotate(-43.353) scale(31.2562 13.6682)"
      >
        <stop stopColor="#A066F4" />
        <stop offset="1" stopColor="#A582E5" stopOpacity="0.2" />
      </radialGradient>
      <radialGradient
        id="paint19_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(244.807 168.721) rotate(134.911) scale(16.0958 36.0219)"
      >
        <stop stopColor="#A066F4" />
        <stop offset="1" stopColor="#A582E5" stopOpacity="0.2" />
      </radialGradient>
      <radialGradient
        id="paint20_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(290.262 180.791) rotate(138.38) scale(31.2963 24.4303)"
      >
        <stop stopColor="white" stopOpacity="0.7" />
        <stop offset="1" stopColor="#EBCEFF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint21_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(230.645 180.914) rotate(135) scale(25.1113 19.6023)"
      >
        <stop stopColor="white" stopOpacity="0.5" />
        <stop offset="1" stopColor="#EBCEFF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint22_radial_3091_408"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(245.476 239.798) rotate(136.38) scale(18.4674 47.495)"
      >
        <stop stopColor="#BE4485" stopOpacity="0.3" />
        <stop offset="1" stopColor="#D5AAE8" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_3091_408">
        <rect
          width="225.39"
          height="198.46"
          fill="white"
          transform="translate(153.373 101.088)"
        />
      </clipPath>
      <clipPath id="clip1_3091_408">
        <rect
          width="97.56"
          height="54.96"
          fill="white"
          transform="translate(205.791 188.017)"
        />
      </clipPath>
    </defs>
  </svg>
);
